import { omit } from 'lodash';

import { BoardDataSource } from '@selfai-platform/bi-domain';

export function convertBoardDataSourceSpecToServer(dataSource: BoardDataSource): BoardDataSource {
  return omit(dataSource, ['type', 'name', 'joins', 'temporary', 'dataSources', 'associations']) as BoardDataSource;
}
